import useHorizon from "../../hooks/useHorizon";

const FeatureSection = () => {
    const slideInRightShort0Animation = useHorizon({preset: 'slideInRightShort', duration: '1000ms', threshold: 1});
    const slideInRightShort200Animation = useHorizon({preset: 'slideInRightShort', duration: '1000ms', delay: '200ms', threshold: 1});
    const slideInRightShort400Animation = useHorizon({preset: 'slideInRightShort', duration: '1000ms', delay: '400ms', threshold: 1});

    return (
        <div className="section-block pt-50 pb-0 bkg-grey-ultralight">
            <div className="row flex">
                <div className="column width-4">
                    <div className="feature-column medium left horizon"
                         {...slideInRightShort0Animation}>
                        <span className="feature-icon icon-database color-green"></span>
                        <div className="feature-text">
                            <h4>SL 기반 메타버스</h4>
                            <p>흑우촌 메타버스는 메타버스의 원조격인 <a href="https://www.secondlife.com">SecondLife</a>
                                &nbsp;환경을 시뮬레이션 하는 <a href="http://www.opensimulator.org">OpenSimulator</a>를 플랫폼으로 사용합니다.
                                직접 메타버스 서버를 운영하기 때문에, 3D 가상공간에 대하여 자주적입니다.</p>
                        </div>
                    </div>
                </div>
                <div className="column width-4">
                    <div className="feature-column medium left horizon"
                         {...slideInRightShort200Animation}>
                        <span className="feature-icon icon-basecamp color-green"></span>
                        <div className="feature-text">
                            <h4>개방적 메타버스</h4>
                            <p>기존 메타버스 공간들은 폐쇄적인 회원제를 채택하거나, 가입을 하더라도 공간 임대와 같은 행위들이 번거로웠습니다. 흑우촌 메타버스는 개방적인 정책으로 자유롭게 이용할 수
                                있는 사이버 공간을 지향합니다.</p>
                        </div>
                    </div>
                </div>
                <div className="column width-4">
                    <div className="feature-column medium left horizon"
                         {...slideInRightShort400Animation}>
                        <span className="feature-icon icon-cycle color-green"></span>
                        <div className="feature-text">
                            <h4>NFT와 융화된 메타버스</h4>
                            <p>NFT 작품을 단순히 3D 가상공간에 전시하는 것 뿐만 아니라, 앞으로 추가될 기능을 통해 NFT의 사용처를 계속해서 찾을 수 있도록 노력하겠습니다.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default FeatureSection;